import { TableInventory } from 'features/inventory';

const Inventory = () => {
  return <TableInventory />;
};

export default Inventory;
